export const createCanvasFromVideo = (video: HTMLVideoElement) => {
    const canvas = document.createElement("canvas")
    canvas.width = video.videoWidth
    canvas.height = video.videoHeight

    const ctx = canvas.getContext("2d", {
        willReadFrequently: true,
        alpha: false,
    })

    if (ctx) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
    }

    const stillImage = new Image()
    stillImage.width = video.videoWidth
    stillImage.height = video.videoHeight

    const dataUrl = canvas.toDataURL()
    stillImage.src = dataUrl

    canvas.style.display = "none"
    setTimeout(() => {
        if (canvas && canvas.parentNode) {
            canvas.parentNode.removeChild(canvas)
        }
    }, 0)

    return {stillImage}
}
